module.exports = __webpack_public_path__ + "static/media/LifeLine1.51b29c0c.png";